import { createFileRoute } from '@tanstack/react-router';
import { FamiliesScreen } from '@/features/catalog/FamiliesScreen';

/**
 * Products › Families (TASK-0259, FRESH-1): the family list (add, rename, retire) and the sheet import
 * (`product_id, family` CSV: dry run, then apply with the check's token).
 */
export const Route = createFileRoute('/_app/products_/families')({
  staticData: { crumb: 'Families' },
  component: FamiliesScreen,
});
